var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"conversion-wrapper"},[_c('app-filter',{attrs:{"filter-list":_vm.table_filter},on:{"search":_vm.search}}),_c('app-table',{ref:"conversion_table_ref",attrs:{"table-key":_vm.table_key,"tablep":_vm.tableParams,"get-data":_vm.getList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }